import ActivateGateway from '@/storage/gateways/ActivateGateway';
import AdvertisingChannelGateway from '@/storage/gateways/AdvertisingChannelGateway';
import AggregatorIntegrationGateway from '@/storage/gateways/AggregatorIntegrationGateway';
import AppointmentScheduleGateway from '@/storage/gateways/AppointmentScheduleGateway';
import AuthGateway from '@/storage/gateways/AuthGateway';
import ArrivalGateway from '@/storage/gateways/ArrivalGateway';
import CabinetGateway from '@/storage/gateways/CabinetGateway';
import CashboxGateway from '@/storage/gateways/CashboxGateway';
import ChiefPhysicianGateway from '@/storage/gateways/ChiefPhysicianModuleGateway';
import CityGateway from '@/storage/gateways/CityGateway';
import OnBoardingGateway from '@/storage/gateways/OnBoardingGateway';
import CrmGateway from '@/storage/gateways/CrmGateway';
import DocumentTemplateGateway from '@/storage/gateways/DocumentTemplateGateway';
import EmployeeGateway from '@/storage/gateways/EmployeeGateway';
import EmployeeRoleGateway from '@/storage/gateways/EmployeeRoleGateway';
import InvoiceGateway from '@/storage/gateways/InvoiceGateway';
import NotificationGateway from '@/storage/gateways/NotificationGateway';
import PatientGateway from '@/storage/gateways/PatientGateway';
import PatientHealthQuestionnaireGateway from '@/storage/gateways/PatientHealthQuestionnaireGateway';
import PayrollGateway from '@/storage/gateways/PayrollGateway';
import PlanGateway from '@/storage/gateways/PlanGateway';
import ProductGateway from '@/storage/gateways/ProductGateway';
import RegisterClinicGateway from '@/storage/gateways/RegisterClinicGateway';
import RegistryNdflCertificateGateway from '@/storage/gateways/RegistryNdflCertificateGateway';
import ReportGateway from '@/storage/gateways/ReportGateway';
import ServiceGateway from '@/storage/gateways/ServiceGateway';
import SettingGateway from '@/storage/gateways/SettingGateway';
import { StorageChange, StorageChangeNotifier } from '@/storage/StorageChange';
import SuggestionGateway from '@/storage/gateways/SuggestionGateway';
import TariffGateway from '@/storage/gateways/TariffGateway';
import TaskGateway from '@/storage/gateways/TaskGateway';
import TelephonyIntegrationGateway from '@/storage/gateways/TelephonyIntegrationGateway';
import UserGateway from '@/storage/gateways/UserGateway';
import VendorGateway from '@/storage/gateways/VendorGateway';
import VisitGateway from '@/storage/gateways/VisitGateway';
import WaitingListGateway from '@/storage/gateways/WaitingListGateway';
import WhatsAppGateway from '@/storage/gateways/WhatsAppGateway';
import WorkScheduleGateway from '@/storage/gateways/WorkScheduleGateway';
import WorkTimeControlsGateway from '@/storage/gateways/WorkTimeControlsGateway';
import WriteOffGateway from '@/storage/gateways/WriteOffGateway';
import NotificationPlansGateway from '@/storage/gateways/NotificationPlansGateway';
import UpdatesGateway from '@/storage/gateways/UpdatesGateway';
import EmployeeActionHistoryGateway from '@/storage/gateways/EmployeeActionHistoryGateway';

/**
 * @description Плагин хранилища.
 * @param {Axios} axios Экземпляр HTTP клиента.
 * @constructor
 * @augments PluginObject
 */
export default function VueStoragePlugin(axios) {
  const storageChangeNotifier = new StorageChangeNotifier();
  const storageChange = new StorageChange(storageChangeNotifier);
  const activateGateway = new ActivateGateway(axios);
  const advertisingChannelGateway = new AdvertisingChannelGateway(axios);
  const aggregatorIntegrationGateway = new AggregatorIntegrationGateway(axios);
  const appointmentScheduleGateway = new AppointmentScheduleGateway(axios);
  const authGateway = new AuthGateway(axios);
  const arrivalGateway = new ArrivalGateway(axios);
  const cabinetGateway = new CabinetGateway(axios);
  const cashboxGateway = new CashboxGateway(axios);
  const chiefPhysicianGateway = new ChiefPhysicianGateway(axios);
  const cityGateway = new CityGateway(axios);
  const onBoardingGateway = new OnBoardingGateway(axios);
  const crmGateway = new CrmGateway(axios);
  const documentTemplateGateway = new DocumentTemplateGateway(axios);
  const employeeActionHistoryGateway = new EmployeeActionHistoryGateway(axios);
  const employeeGateway = new EmployeeGateway(axios);
  const employeeRoleGateway = new EmployeeRoleGateway(axios);
  const invoiceGateway = new InvoiceGateway(axios);
  const notificationGateway = new NotificationGateway(axios);
  const notificationPlansGateway = new NotificationPlansGateway(axios);
  const patientGateway = new PatientGateway(axios);
  const patientHealthQuestionnaireGateway = new PatientHealthQuestionnaireGateway(axios);
  const payrollGateway = new PayrollGateway(axios);
  const planGateway = new PlanGateway(axios);
  const productGateway = new ProductGateway(axios);
  const registerClinicGateway = new RegisterClinicGateway(axios);
  const registryNdflCertificateGateway = new RegistryNdflCertificateGateway(axios);
  const reportGateway = new ReportGateway(axios);
  const serviceGateway = new ServiceGateway(axios);
  const settingGateway = new SettingGateway(axios, storageChangeNotifier);
  const suggestionGateway = new SuggestionGateway(axios);
  const tariffGateway = new TariffGateway(axios);
  const taskGateway = new TaskGateway(axios);
  const updatesGateway = new UpdatesGateway(axios);
  const telephonyIntegrationGateway = new TelephonyIntegrationGateway(axios);
  const userGateway = new UserGateway(axios);
  const vendorGateway = new VendorGateway(axios);
  const visitGateway = new VisitGateway(axios);
  const waitingListGateway = new WaitingListGateway(axios);
  const whatsAppGateway = new WhatsAppGateway(axios);
  const workScheduleGateway = new WorkScheduleGateway(axios);
  const workTimeControlsGateway = new WorkTimeControlsGateway(axios);
  const writeOffGateway = new WriteOffGateway(axios);
  /**
   * @description Установить расширения прототипа Vue.
   * @param {VueConstructor} Vue Конструктор компонента.
   * @returns {void}
   */
  this.install = (Vue) => {
    Object.defineProperties(
      Vue.prototype,
      {
        $activateGateway: {
          get() {
            return activateGateway;
          },
        },
        $advertisingChannelGateway: {
          get() {
            return advertisingChannelGateway;
          },
        },
        $aggregatorIntegrationGateway: {
          get() {
            return aggregatorIntegrationGateway;
          },
        },
        $appointmentScheduleGateway: {
          get() {
            return appointmentScheduleGateway;
          },
        },
        $authGateway: {
          get() {
            return authGateway;
          },
        },
        $arrivalGateway: {
          get() {
            return arrivalGateway;
          },
        },
        $cabinetGateway: {
          get() {
            return cabinetGateway;
          },
        },
        $cashboxGateway: {
          get() {
            return cashboxGateway;
          },
        },
        $chiefPhysicianGateway: {
          get() {
            return chiefPhysicianGateway;
          },
        },
        $cityGateway: {
          get() {
            return cityGateway;
          },
        },
        $onBoardingGateway: {
          get() {
            return onBoardingGateway;
          },
        },
        $crmGateway: {
          get() {
            return crmGateway;
          },
        },
        $documentTemplateGateway: {
          get() {
            return documentTemplateGateway;
          },
        },
        $employeeActionHistoryGateway: {
          get() {
            return employeeActionHistoryGateway;
          },
        },
        $employeeGateway: {
          get() {
            return employeeGateway;
          },
        },
        $employeeRoleGateway: {
          get() {
            return employeeRoleGateway;
          },
        },
        $invoiceGateway: {
          get() {
            return invoiceGateway;
          },
        },
        $notificationGateway: {
          get() {
            return notificationGateway;
          },
        },
        $notificationPlansGateway: {
          get() {
            return notificationPlansGateway;
          },
        },
        $patientGateway: {
          get() {
            return patientGateway;
          },
        },
        $planGateway: {
          get() {
            return planGateway;
          },
        },
        $patientHealthQuestionnaireGateway: {
          get() {
            return patientHealthQuestionnaireGateway;
          },
        },
        $payrollGateway: {
          get() {
            return payrollGateway;
          },
        },
        $productGateway: {
          get() {
            return productGateway;
          },
        },
        $registerClinicGateway: {
          get() {
            return registerClinicGateway;
          },
        },
        $registryNdflCertificateGateway: {
          get() {
            return registryNdflCertificateGateway;
          },
        },
        $reportGateway: {
          get() {
            return reportGateway;
          },
        },
        $serviceGateway: {
          get() {
            return serviceGateway;
          },
        },
        $suggestionGateway: {
          get() {
            return suggestionGateway;
          },
        },
        $settingGateway: {
          get() {
            return settingGateway;
          },
        },
        $tariffGateway: {
          get() {
            return tariffGateway;
          },
        },
        $taskGateway: {
          get() {
            return taskGateway;
          },
        },
        $telephonyIntegrationGateway: {
          get() {
            return telephonyIntegrationGateway;
          },
        },
        $userGateway: {
          get() {
            return userGateway;
          },
        },
        $vendorGateway: {
          get() {
            return vendorGateway;
          },
        },
        $visitGateway: {
          get() {
            return visitGateway;
          },
        },
        $waitingListGateway: {
          get() {
            return waitingListGateway;
          },
        },
        $updatesGateway: {
          get() {
            return updatesGateway;
          },
        },
        $whatsAppGateway: {
          get() {
            return whatsAppGateway;
          },
        },
        $workScheduleGateway: {
          get() {
            return workScheduleGateway;
          },
        },
        $workTimeControlsGateway: {
          get() {
            return workTimeControlsGateway;
          },
        },
        $writeOffGateway: {
          get() {
            return writeOffGateway;
          },
        },
      },
    );
    Vue.mixin({
      destroyed() {
        this.$emit('storage-change-closed');
      },
    });
    Object.defineProperty(Vue.prototype, '$storageChangeOn', {
      value: (component) => (id, handler) => {
        const number = storageChange.on(id, handler);
        component.$on('storage-change-closed', () => { storageChange.off(number); });
      },
    });
  };
}
